import { render } from "./Unit3-4-game.vue?vue&type=template&id=903cb5f8&scoped=true"
import script from "./Unit3-4-game.vue?vue&type=script&lang=js"
export * from "./Unit3-4-game.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit3-4-game.css?vue&type=style&index=1&id=903cb5f8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903cb5f8"]])

export default __exports__